import { Icons } from "@/components/icons";
import { Code, FileText, HomeIcon, Mail, UserRound } from "lucide-react";
export const DATA = {
  name: "Rapheal Kwabena Asomani Gadoh",
  url: "https://www.raphealgadoh.me/",
  description: "Full Stack Engineer · Tech Innovator · STEM Educator",
  description2: "Bridging the gap between",
  description3: "technology and social impact — building scalable digital solutions and empowering the next generation of African tech leaders.",
  summary: "I'm Rapheal Kwabena Asomani Gadoh — a Full Stack Engineer and Social Innovator currently based in the United States. I build scalable, production-ready web applications and digital platforms while actively mentoring the next generation of tech talent. My mission sits at the intersection of technical excellence and social impact: empowering young people — especially girls — to become creators, not just consumers, of technology. I've shipped real products, won national hackathons, and taught STEM to 1000+ students. I care deeply about clean code, thoughtful UX, and solutions that outlast their creators.",
  appreciation: "Throughout my journey, I've tackled complex engineering challenges, built functional and aesthetically polished UIs, and contributed to products that measurably improve people's lives and workflows.",
  footer: "Always eager to connect with builders, founders, and change-makers. Let's collaborate on something meaningful.",

  linkedin: [
    {
      title: "Rapheal Kwabena Asomani Gadoh",
      href: "https://www.linkedin.com/in/younggem",
      icon: "/linkedin-logo.svg",
      profile: "https://media.licdn.com/dms/image/v2/D4E03AQH_6dFyhj0qKw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1711214175222?e=1747872000&v=beta&t=xRKUvV7cm1gEHOxmbJcQZo-o2LsBrKmz6ZSfXLKlDM8",
    },
  ],
  github: [
    {
      title: "Rapheal-Kwabena",
      href: "https://github.com/Rapheal-Kwabena",
      icon: "/github-logo.svg",
      profile: "/avatar.png",
    }
  ],
  images: [
    {
      title: "The Grind",
      href: "/Coding.jpg",
    },
    {
      title: "Me",
      href: "/avatar.jpeg",
    },
    {
      title: "ALX x Stermaid Hackathon",
      href: "/Alx stemaide Hackathon.jpg",
    },
    {
      title: "The wining team",
      href: "/hackathon.jpg",
    },
    {
      title: "while exploring",
      href: "/explore.jpg",
    },
    {
      title: "Volunteering",
      href: "/Volunteering 4.jpg",
    },
    {
      title: "Coolest Ghana Projects",
      href: "/Volunteering 2(Coolest Ghana projects).jpeg",
    },
  ],
  Iconsvg: [
    {
      id: 1,
      title: "TypeScript",
      href: "/typescript.svg",
      site: "https://www.typescriptlang.org",
    },
    {
      id: 2,
      title: "Next.js",
      href: "/next-logo.svg",
      site: "https://nextjs.org",
    },
    {
      id: 3,
      title: "React",
      href: "/react-logo.svg",
      site: "https://react.dev",
    },
  ],
  skillsdescription: "Here’s a section showcasing the skills I’ve learned and use frequently. Languages: English (Native/Bilingual), French (Elementary), Spanish (Limited Working).",
  Skills: [
    {
      id: 1,
      title: "React Native",
      href: "/react-logo.svg",
      site: "https://reactnative.dev",
    },
    {
      id: 2,
      title: "React",
      href: "/react-logo.svg",
      site: "https://react.dev",
    },
    {
      id: 3,
      title: "Web Development",
      href: "/javascript.svg",
      site: "https://developer.mozilla.org/en-US/docs/Web/Guide",
    },

    {
      id: 5,
      title: "Next.js",
      href: "/next-logo.svg",
      site: "https://nextjs.org",
    },
    {
      id: 6,
      title: "Typescript",
      href: "/typescript.svg",
      site: "https://www.typescriptlang.org/",
    },
    {
      id: 7,
      title: "Python",
      href: "/python.svg",
      site: "https://www.python.org/",
    },
    {
      id: 8,
      title: "Tailwind CSS",
      href: "/tailwindcss.svg",
      site: "https://tailwindcss.com/",
    },
    {
      id: 9,
      title: "Framer Motion",
      href: "/fm.svg",
      site: "https://react.dev",
    },
    {
      id: 10,
      title: "Php",
      href: "/php-color.svg",
      site: "https://react.dev",
    },
    {
      id: 11,
      title: "MySQL",
      href: "/mysql.svg",
      site: "https://react.dev",
    },
    {
      id: 12,
      title: "Git",
      href: "/git.svg",
      site: "https://react.dev",
    },
    {
      id: 13,
      title: "AWS",
      href: "/aws.svg",
      site: "https://react.dev",
    },
  ],
  navbar: [
    { href: "/", icon: HomeIcon, label: "Home" },
    { href: "/about", icon: UserRound, label: "About" },
    { href: "/projects", icon: Code, label: "Projects" },
    { href: "/resume", icon: FileText, label: "Resume" },
    { href: "/contact", icon: Mail, label: "Contact" },
  ],
  contact: {
    social: {
      GitHub: {
        name: "GitHub",
        url: "https://github.com/Rapheal-Kwabena",
        icon: Icons.github,
        navbar: true,
      },
      LinkedIn: {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/younggem",
        icon: Icons.linkedin,
        navbar: true,
      },
      Email: {
        name: "Email",
        url: "mailto:raphealasomanikwabena@gmail.com",
        icon: Icons.email,
        navbar: true,
      },
    },
  },
  worksummary: "A journey of impactful contributions and continuous growth. Here's a breakdown of my professional experience, where I've leveraged technology to drive innovation and support community initiatives.",
  work: [
    {
      id: 1,
      company: "International Youth Council on Gender Equality",
      href: "#",
      title: "Director, Technology & Innovation",
      logoUrl: "/iycge.jpg",
      start: "September 2025",
      end: "January 2026",
      description:
        "As Director of Technology & Innovation, I oversaw the Council's digital infrastructure and led initiatives to improve processes, outreach, and engagement through technology. I managed website development, ensured data security, and coordinated with other directors to implement innovative solutions. I also guided interns and volunteers on digital projects while shaping policies and best practices.",
    },
    {
      id: 2,
      company: "Afrikan STEM Force",
      href: "#",
      title: "Volunteer Robotics Instructor",
      logoUrl: "/Afrikan Stem force.png",
      start: "January 2024",
      end: "March 2026",
      description:
        "Helped in educating over 1000+ girls across Ghana, empowering them with STEM knowledge and robotics skills.",
    },
    {
      id: 3,
      company: "STEMAIDE",
      href: "#",
      title: "Engineering Intern",
      logoUrl: "/stemaide.png",
      start: "September 2025",
      end: "October 2025",
      description:
        "Part of the Engineering department, helping build robots and design kits components. Assisted in developing a structure suitable for people of all ages.",
    },
    {
      id: 4,
      company: "myTickets",
      href: "#",
      title: "Digital Marketing and Software Developer Intern",
      logoUrl: "/myTickets.jpg",
      start: "September 2024",
      end: "December 2024",
      description:
        "myTickets is a ticket sales platform committed to providing sports fans a safe, affordable way to sell tickets back to their community. Worked on digital marketing and software development to establish the platform's trusted reputation.",
    },
    {
      id: 5,
      company: "Firefly IO",
      href: "#",
      title: "Volunteer Robotics Instructor",
      logoUrl: "/firefly io.jpg",
      start: "May 2024",
      end: "September 2024",
      description:
        "Challenged traditional education norms by empowering young individuals with STEAM knowledge, helping to transform communities and increase opportunities for technology-related careers.",
    },
    {
      id: 6,
      company: "Xcelsz Property (XP)",
      href: "#",
      title: "Agile Marketing Developer and Visual Architect intern",
      logoUrl: "/xcelsz property.jpg",
      start: "February 2024",
      end: "May 2024",
      description:
        "Results-driven designer using advanced visual design principles and agile methodologies to create impactful brand experiences. Collaborated with cross-functional teams, implementing agile workflows for rapid improvement and adapting to market changes.",
    },
  ],
  educationsummary: "A foundation built on curiosity and rigorous learning. From high school business studies to advanced artificial intelligence and information technology, my education has equipped me with the tools to innovate.",
  education: [
    {
      id: 0,
      school: "University of Arkansas Pine Bluff",
      href: "https://www.uapb.edu",
      degree: "Bachelor of Science, Computer Science",
      logoUrl: "/UAPB.jpeg",
      start: "August 2026",
      end: "May 2030",
      description: "Pursuing a Computer Science degree with a focus on software engineering, systems, and artificial intelligence. Expected graduation: May 2030.",
      coursework: true,
    },
    {
      id: 1,
      school: "African Leadership Experience",
      href: "#",
      degree: "IA Career Essential, Artificial Intelligence",
      logoUrl: "/alx.png",
      start: "July 2024",
      end: "August 2024",
      description: "Specialized training in Artificial Intelligence fundamentals and career essentials.",
    },
    {
      id: 2,
      school: "Adisadel College",
      href: "#",
      degree: "High School Diploma, Business",
      logoUrl: "/adisadel college.jpg",
      start: "March 2021",
      end: "September 2023",
      description: "Studied Business, gaining foundational knowledge in economic principles and business management.",
    },
  ],
  certificationssummary: "Professional certifications that validate my expertise and commitment to continuous learning in cloud platforms, AI, banking, and cybersecurity.",
  certifications: [
    {
      id: 1,
      organization: "Verizon",
      title: "Cloud Platform Job Simulation",
      logoUrl: "/verizon.png",
      description: "Practical simulation experience with cloud platform technologies and operations.",
    },
    {
      id: 2,
      organization: "ALX / The Aice",
      title: "Aice AI Career Essential",
      logoUrl: "/alx.png",
      description: "Essential skills and knowledge for a career in Artificial Intelligence.",
    },
    {
      id: 3,
      organization: "JPMorgan Chase",
      title: "Investment Banking Job Simulation",
      logoUrl: "/jp morgan.png",
      description: "Experience in investment banking operations and financial analysis through job simulation.",
    },
    {
      id: 4,
      organization: "Netcad",
      title: "Certificate of Learning Internet Security",
      logoUrl: "/Netcad.jpg",
      description: "Foundational knowledge in internet security and threat prevention.",
    },
  ],
  projectssummary: "Explore my projects where ideas meet execution. Each project showcases my dedication to crafting impactful digital experiences, turning concepts into reality.",
  projects: [
    {
      title: "Gadoh Autos",
      href: "https://gadoh-autos.vercel.app/",
      dates: "2026",
      active: true,
      description:
        "Ghana's premier showcase for genuine OEM and high-performance aftermarket auto parts. Features an interactive component catalog, compatibility verification support, and integrated WhatsApp communications for offline pricing inquiries.",
      iconLists: ["/next-logo.svg", "/typescript.svg", "/tailwindcss.svg"],
      links: [
        {
          type: "Website",
          href: "https://gadoh-autos.vercel.app/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/gadoh-autos-preview.png",
      video: "",
    },
    {
      title: "Arduino GitHub Pusher",
      href: "/arduino-github-pusher-1.0.0.vsix",
      dates: "2026",
      active: true,
      description:
        "A lightweight VS Code & Arduino IDE 2.x extension that lets you push sketches to GitHub in one click. Features secure token storage, smart project detection, async non-blocking architecture, and zero-dependency esbuild bundling (~700 KB).",
      iconLists: ["/typescript.svg", "/git.svg", "/github-logo.svg"],
      links: [
        {
          type: "Download",
          href: "/arduino-github-pusher-1.0.0.vsix",
          icon: <Icons.github className="size-3" />,
        },
        {
          type: "Connect IDE",
          href: "/connect",
          icon: <Icons.globe className="size-3" />,
        },
        {
          type: "Blog",
          href: "/blog/arduino-github-pusher",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/arduino_github_pusher_preview.png",
      video: "",
    },
    {
      title: "PyWorkflow Framework",
      href: "https://pypi.org/project/pyworkflow-framework/",
      dates: "2026",
      active: true,
      description:
        "A lightweight, developer-friendly Python workflow automation framework for building declarative task pipelines. Supports topological dependency graphs, parallel workers, automatic retries with backoff, history logging, and a robust CLI.",
      iconLists: ["/python.svg", "/git.svg"],
      links: [
        {
          type: "PyPI",
          href: "https://pypi.org/project/pyworkflow-framework/",
          icon: <Icons.globe className="size-3" />,
        },
        {
          type: "Source",
          href: "https://github.com/Rapheal-Kwabena/pyworkflow",
          icon: <Icons.github className="size-3" />,
        },
      ],
      image: "/pyworkflow_preview.png",
      video: "",
    },
    {
      title: "react-pyworkflow",
      href: "https://www.npmjs.com/package/react-pyworkflow",
      dates: "2026",
      active: true,
      description:
        "A lightweight React/TypeScript workflow orchestration library. Brings declarative dependency graphs, async task execution, retries, and real-time task tracking hooks directly to client-side applications.",
      iconLists: ["/react-logo.svg", "/typescript.svg", "/npm.svg"],
      links: [
        {
          type: "NPM",
          href: "https://www.npmjs.com/package/react-pyworkflow",
          icon: <Icons.globe className="size-3" />,
        },
        {
          type: "Source",
          href: "https://github.com/Rapheal-Kwabena/pyworkflow",
          icon: <Icons.github className="size-3" />,
        },
      ],
      image: "/react_pyworkflow_preview.png",
      video: "",
    },
    {
      title: "MovieRoom App",
      href: "https://movieroom-app.vercel.app/",
      dates: "2025",
      active: true,
      description:
        "A dynamic movie discovery platform built with React and TMDB API, featuring real-time search, detailed movie information, and a responsive interface.",
      iconLists: ["/react-logo.svg", "/tailwindcss.svg", "/javascript.svg"],
      links: [
        {
          type: "Website",
          href: "https://movieroom-app.vercel.app/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/movieroom.png",
      video: "",
    },
    {
      title: "EduLearn Trivia",
      href: "https://edulearn-trivial.vercel.app/",
      dates: "2025",
      active: true,
      description:
        "An interactive educational trivia game designed to make learning engaging. Features multiple categories, score tracking, and a user-friendly design.",
      iconLists: ["/react-logo.svg", "/tailwindcss.svg", "/javascript.svg"],
      links: [
        {
          type: "Website",
          href: "https://edulearn-trivial.vercel.app/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/Edulearn.png",
      video: "",
    },
    {
      title: "Sustainable Education",
      href: "https://sustainable-education.vercel.app/",
      dates: "2025",
      active: true,
      description:
        "A dedicated platform promoting sustainable education practices. Provides resources and information to foster environmental awareness and action.",
      iconLists: ["/next-logo.svg", "/tailwindcss.svg", "/typescript.svg"],
      links: [
        {
          type: "Website",
          href: "https://sustainable-education.vercel.app/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/sustainable.png",
      video: "",
    },
    {
      title: "Stepworth Ghana",
      href: "https://www.stepworthgh.com/",
      dates: "2025",
      active: true,
      description:
        "Official website for Stepworth Ghana, delivering a professional digital presence to showcase their services and connect with clients.",
      iconLists: ["/react-logo.svg", "/tailwindcss.svg", "/javascript.svg"],
      links: [
        {
          type: "Website",
          href: "https://www.stepworthgh.com/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/Stepworthgh.png",
      video: "",
    },
    {
      title: "IYCGE",
      href: "https://www.iycge.org/",
      dates: "2025",
      active: true,
      description:
        "The official platform for the International Youth Council on Gender Equality. Facilitates outreach, resource sharing, and global collaboration.",
      iconLists: ["/react-logo.svg", "/tailwindcss.svg", "/javascript.svg"],
      links: [
        {
          type: "Website",
          href: "https://www.iycge.org/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/iycge.png",
      video: "",
    },
    {
      title: "Gramics Foundation",
      href: "https://gramics-foundation.vercel.app/",
      dates: "2026",
      active: true,
      description:
        "Official website for the Gramics Foundation — a platform driving creative and educational initiatives across Africa. Built with a focus on accessibility, storytelling, and community impact.",
      iconLists: ["/react-logo.svg", "/tailwindcss.svg", "/javascript.svg"],
      links: [
        {
          type: "Website",
          href: "https://gramics-foundation.vercel.app/",
          icon: <Icons.globe className="size-3" />,
        },
      ],
      image: "/gramics.png",
      video: "",
    },
  ],
  contributionssummary: "Dedicated to giving back. My journey is defined not just by what I build, but by who I uplift along the way. Here are some of the community initiatives I've been privileged to be a part of.",
  contributions: [
    {
      link: "#",
      title: "Empowering Girls in STEM",
      description: "Volunteering with Afrikan STEM Force to educate over 1000+ girls across Ghana. Witnessing their curiosity turn into confidence as they built their first robots was a truly transformative experience. We are bridging the gender gap in technology one workshop at a time.",
      image: "/Afrikan Stem force.png",
      stars: "",
      forks: "",
    },
    {
      link: "#",
      title: "Community Outreach & Education",
      description: "Engaging with local communities to demystify technology. From teaching basic computer literacy to advanced coding concepts, every session is a step towards a more digitally inclusive society.",
      image: "/Volunteering 4.jpg",
      stars: "",
      forks: "",
    },
    {
      link: "#",
      title: "Building the Future at Hackathons",
      description: "Participating and mentoring at hackathons like the ALX Stemaide Hackathon. It's about more than just winning; it's about collaborative problem-solving and inspiring the next generation of innovators.",
      image: "/Alx stemaide Hackathon.jpg",
      stars: "",
      forks: "",
    },
    {
      link: "#",
      title: "Transforming Education with STEAM",
      description: "With Firefly IO, we challenged traditional education norms. Empowering young minds with STEAM knowledge is not just about skills; it's about critical thinking and creating opportunities for the future.",
      image: "/firefly io.jpg",
      stars: "",
      forks: "",
    },
  ],
  hackathonsummary: "Recognition of excellence and dedication. A collection of honors and awards received for achievements in technology, leadership, and community service.",
  hackathons: [
    {
      id: 1,
      title: "Overall Winner National Cybersecurity Hackathon",
      dates: "2022",
      location: "Ghana",
      description:
        "Awarded Overall Winner at the National Cybersecurity Hackathon for demonstrating exceptional skills in cybersecurity challenges.",
      logo: "/National_Cybersecurity_authority.jpg",
      images: "",
      mlh: "https://s3.amazonaws.com/logged-assets/trust-badge/2019/mlh-trust-badge-2019-white.svg",
      links: [],
    },
    {
      id: 2,
      title: "Alumni Award First Lego League",
      dates: "2024",
      location: "Ghana",
      description:
        "Received the Alumni Award for outstanding contributions and representation of the institution.",
      logo: "/First lego league.png",
      images: "",
      mlh: "",
      links: [],
    },
    {
      id: 3,
      title: "2x Award Winner",
      dates: "2021 - 2023",
      location: "Adisadel College",
      description:
        "Two-time recipient of the Winners Award for excellence in competitions at Adisadel College.",
      logo: "/adisadel college.jpg",
      images: "",
      mlh: "",
      links: [],
    },
    {
      id: 4,
      title: "2x Volunteer of the Month",
      dates: "2024",
      location: "Afrikan STEM Force",
      description:
        "Recognized twice as Volunteer of the Month for dedication and impactful service to the community.",
      logo: "/Afrikan Stem force.png",
      images: "",
      mlh: "",
      links: [],
    },
    {
      id: 5,
      title: "ALX × STEMAIDE Hackathon — Winner",
      dates: "2025",
      location: "Accra, Ghana",
      description:
        "Competed in the ALX × STEMAIDE Hackathon, building an innovative tech solution under time pressure. Awarded for outstanding creativity, technical execution, and real-world impact.",
      logo: "/alx.png",
      images: "",
      mlh: "",
      links: [],
    },
  ],
} as const;